export default "__VITE_ASSET__447ca825__"